import React from 'react';
import styled from 'styled-components';
import { any, bool, func } from 'prop-types';
import Text from '../Text';
import { If } from '../../shared';

const InfoTagContainer = styled.div`
    border-radius: 12px;
    background-color: ${({ background }) => background || '#f4f4f4'};
    padding: 2px 13px;
    margin 5px;
    font-size: 12px;
    display: ${({ removable }) => removable ? 'flex' : 'inline-block'};
`;

const RemoverContainer = styled.div`
    margin: 0 -10px 0 5px;
    padding: 0px 6px;
    border-radius: 50%;
    align-items: end;
    background-color: #c6c6c6;
    cursor: pointer;
    :hover {
        background-color: #89a503;
    }
`;

const InfoTag = ({ children, removable, onRemove, ...props }) => {
    const infoTagContainerProps = {
        removable,
        ...props
    };

    return (
        <InfoTagContainer {...infoTagContainerProps}>
            { children }
            <If
                condition={removable}
                then={
                    <RemoverContainer onClick={onRemove}>
                        <Text text='x' strong color='#FFFFFF' />
                    </RemoverContainer>
                }
            />
        </InfoTagContainer>
    );
};

InfoTag.propTypes = {
    children: any,
    removable: bool,
    onRemove: func
};

InfoTag.defaultProps = {
    onRemove: () => {}
};

export default InfoTag;
